<template>
    <v-container @keydown="CheckInvio()">
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog persistent max-width="600" v-model="showDeleteAlert" :z-index="5000">
            <v-card>
                <v-card-title>{{ $t('manageSensors.sensorDeleting') }}</v-card-title>
                <v-card-text>
                    <h4>{{ $t('manageSensors.deleteConfirm', { name: nameDeleting }) }}</h4>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="showDeleteAlert = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="ConfirmDelete">{{ $t('common.ok') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAddBuilding" :z-index="5000">
            <v-card>
                <v-card-title>
                    {{ $t('building.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="buildingForm" v-model="isBuildingFormValid">
                        <v-text-field v-model="newBuildingName" :label="$t('building.fields.name')" outlined
                            color="#213A8F" maxlength="50" counter :rules="[rules.required]" />
                        <v-text-field v-model="newBuildingAddress" :label="$t('building.fields.address')" outlined
                            color="#213A8F" maxlength="50" counter :rules="[rules.required]" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAddBuilding = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateBuilding" :disabled="!isBuildingFormValid">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAddFloor" :z-index="5000">
            <v-card>
                <v-card-title>
                    {{ $t('floor.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="floorForm" v-model="isFloorFormValid">
                        <v-select v-model="buildingValue" color="#213A8F" outlined :items="buildings"
                            :label="$t('floor.fields.building')" prepend-inner-icon="mdi-home"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            v-if="showBuilding" :disabled="true" :rules="[rules.required]"
                            :no-data-text="$t('common.noDataAvailable')" />
                        <v-text-field v-model="newFloorName" :label="$t('floor.fields.name')" outlined color="#213A8F"
                            maxlength="50" counter :rules="[rules.required]" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAddFloor = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateFloor" :disabled="!isFloorFormValid">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAddArea" :z-index="5000">
            <v-card>
                <v-card-title>
                    {{ $t('area.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="areaForm" v-model="isAreaFormValid">
                        <v-select v-model="buildingValue" color="#213A8F" outlined :items="buildings"
                            :label="$t('area.fields.building')" prepend-inner-icon="mdi-home"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            v-if="showBuilding" :disabled="true" :rules="[rules.required]"
                            :no-data-text="$t('common.noDataAvailable')" />
                        <v-select v-model="floorValue" color="#213A8F" outlined :items="floors"
                            :label="$t('area.fields.floor')" prepend-inner-icon="mdi-floor-plan"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F" :key="f"
                            v-if="showFloor" :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />
                        <v-text-field v-model="newAreaName" :label="$t('area.fields.name')" outlined color="#213A8F"
                            maxlength="50" counter :rules="[rules.required]" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAddArea = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateArea" :disabled="!isAreaFormValid">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="600" v-model="dialogAdd" :z-index="1000">
            <v-card>
                <v-card-title>
                    {{ $t('sensor.add.title') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="form" v-model="isFormValid">
                        <v-text-field v-model="devEui" :label="$t('sensor.fields.sensorId')" outlined color="#213A8F"
                            maxlength="50" counter :rules="[rules.required, rules.uniqueDevEui]" />

                        <v-text-field v-model="dispenserName" :label="$t('sensor.fields.dispenserName')" outlined
                            color="#213A8F" maxlength="20" counter :rules="[rules.required]" />

                        <v-select v-model="dispenserBrand" color="#213A8F" outlined :items="dispenserBrands"
                            :label="$t('sensor.fields.dispenserBrand')" prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="showDispenserArticleCode" v-model="dispenserArticleCode" color="#213A8F"
                            outlined :items="dispenserArticleCodes" :label="$t('sensor.fields.dispenserArticleCode')"
                            prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="showConsumableBrand" v-model="consumableBrand" color="#213A8F" outlined
                            :items="consumableBrands" :label="$t('sensor.fields.consumableBrand')"
                            prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-if="showConsumableArticleCode" v-model="consumableArticleCode" color="#213A8F"
                            outlined :items="consumableArticleCodes" :label="$t('sensor.fields.consumableArticleCode')"
                            prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-select v-model="client" color="#213A8F" outlined :items="clients"
                            :label="$t('sensor.fields.client')" prepend-inner-icon="mdi-account"
                            append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                            :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />

                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select v-if="showBuilding" v-model="buildingValue" color="#213A8F" outlined
                                    :items="buildings" :label="$t('sensor.fields.building')"
                                    prepend-inner-icon="mdi-home" append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" :rules="[rules.required]"
                                    :no-data-text="$t('common.noDataAvailable')" />
                            </v-flex>
                            <v-flex xs-1 md-1 sm-1>
                                <v-icon v-if="showBuilding" class="mt-4 mb-4" color="#213A8F" text
                                    @click="CreateNewBuilding()">mdi-plus-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select v-if="showFloor" v-model="floorValue" color="#213A8F" outlined :items="floors"
                                    :label="$t('sensor.fields.floor')" prepend-inner-icon="mdi-floor-plan"
                                    append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                                    :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />
                            </v-flex>
                            <v-flex xs-1 md-1 sm-1>
                                <v-icon v-if="showFloor" class="mt-4 mb-4" color="#213A8F" text
                                    @click="CreateNewFloor()">mdi-plus-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select v-if="showArea" v-model="areaValue" color="#213A8F" outlined :items="areas"
                                    :label="$t('sensor.fields.area')" prepend-inner-icon="mdi-texture-box"
                                    append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                                    :rules="[rules.required]" :no-data-text="$t('common.noDataAvailable')" />
                            </v-flex>
                            <v-flex xs-1 md-1 sm-1>
                                <v-icon v-if="showArea" class="mt-4 mb-4" color="#213A8F" text
                                    @click="CreateNewArea()">mdi-plus-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAdd = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CreateSensor" :disabled="!isFormValid">
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <div v-if="addButton">
                <v-icon class="mt-4 mb-4" color="#213A8F" text @click="CreateNew()">mdi-plus-circle-outline</v-icon>{{ $t('manageSensors.addNewSensor') }}
            </div>
            <v-card class="mt-4 mb-4">
                <v-layout id="makeMeBlue">
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select v-model="filterClient" color="#213A8F" outlined :items="filterClients" :label="$t('manageSensors.client')"
                            prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" :no-data-text="$t('manageSensors.noDataAvailable')" />
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select prepend-inner-icon="mdi-home" v-model="filterBuilding" :items="filterBuildings"
                            :label="$t('manageSensors.building')" outlined append-icon="mdi-arrow-down-drop-circle-outline"
                            :no-data-text="$t('manageSensors.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select prepend-inner-icon="mdi-floor-plan" class="ml-2"
                            append-icon="mdi-arrow-down-drop-circle-outline" v-model="filterFloor" :items="filterFloors"
                            :label="$t('manageSensors.floor')" outlined :no-data-text="$t('manageSensors.noDataAvailable')">
                        </v-select>
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select v-model="filterArea" color="#213A8F" outlined :items="filterAreas" :label="$t('manageSensors.area')"
                            prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" :no-data-text="$t('manageSensors.noDataAvailable')" />
                    </v-flex>
                    <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                        <v-select v-model="filterSensor" prepend-inner-icon="mdi-access-point-network"
                            append-icon="mdi-arrow-down-drop-circle-outline" :items="filterSensors" :label="$t('manageSensors.sensor')"
                            outlined :no-data-text="$t('manageSensors.noDataAvailable')">
                        </v-select>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-btn text @click="ClearFilter">
                        <span style="color: #213A8F;">{{ $t('manageSensors.clearFilter') }}</span>
                        <v-icon color="#213A8F" left>mdi-close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="Filter">
                        <span style="color: #213A8F;">{{ $t('manageSensors.filter') }}</span>
                        <v-icon color="#213A8F" left>mdi-magnify</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card>
                <!-- <v-card-actions class="mb-0">
                    <v-spacer></v-spacer>
                    <v-layout>
                        <v-flex xs3 sm3 md3>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                outlined></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-actions> -->
                <v-card-text class="mt-0">
                    <v-data-table v-bind:headers="filteredHeaders" :items="items" :hide-default-footer="true"
                        disable-pagination class="elevation-1" :search="search" no-data-text="No devices connected yet">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>
                                    <v-icon v-if="item.status == 'on'"
                                        :style="{ color: $route.params.type === 'washroom' ? item.cleaningStatusColor : item.stato }">
                                        mdi-checkbox-blank-circle
                                    </v-icon>
                                </td>
                                <td>
                                    <img class="mt-2 mr-4 align-center" style="width: 50px; align-content:center"
                                        :src="item.DispenserType" />
                                </td>
                                <!-- Colonna Fill Level per dispenser -->
                                <td v-if="$route.params.type === 'dispenser'">{{ item.status == 'on' && item.percentuale
                                    > -1 ? (item.percentuale + '%') : '' }}
                                </td>
                                <!-- Colonna Live Usage per washroom -->
                                <td v-if="$route.params.type === 'washroom'">
                                    {{ item.liveUsage }}
                                </td>
                                <!-- Colonna Cleaning Limit per washroom -->
                                <td v-if="$route.params.type === 'washroom'">
                                    {{ item.cleaningLimit }}
                                </td>
                                <td>
                                    <a v-if="$route.params.type === 'dispenser'" @click="navigateToSmartDispenser(item)"
                                        style="color: #213A8F; cursor: pointer; text-decoration: underline;">
                                        {{ item.name }}
                                    </a>
                                    <a v-else-if="$route.params.type === 'washroom'"
                                        @click="navigateToSmartCleaning(item)"
                                        style="color: #213A8F; cursor: pointer; text-decoration: underline;">
                                        {{ item.name }}
                                    </a>
                                    <span v-else>{{ item.name }}</span>
                                </td>
                                <td>{{ item.Company }}</td>
                                <td>{{ item.BuildingName }}</td>
                                <td>{{ item.floor }}</td>
                                <td>{{ item.Area }}</td>
                                <td v-if="item.battery > 0">{{ item.battery }}%</td>
                                <td v-else></td>
                                <td>{{ item.sensorId }}</td>
                                <td>
                                    <v-icon color="#213A8F" text class="mr-2"
                                        @click="editSensor(item)">mdi-pencil</v-icon>
                                    <v-icon color="#213A8F" text
                                        @click="AlertDeleting(item.id, item.name)">mdi-delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-card>
        <v-dialog persistent max-width="600" v-model="dialogEdit" :z-index="1000">
            <v-card>
                <v-card-title>
                    {{ $t('manageSensors.editSensor') }} : {{ editingSensorName }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-text-field label="Sensor ID" v-model="devEui" outlined color="#213A8F" maxlength="50" counter
                        :disabled="true" />
                    <v-text-field label="Dispenser Name" v-model="dispenserName" outlined color="#213A8F" maxlength="20"
                        counter />
                    <v-select v-model="dispenserBrand" color="#213A8F" outlined :items="dispenserBrands"
                        label="Dispenser Brand" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="dispenserArticleCode" color="#213A8F" outlined :items="dispenserArticleCodes"
                        label="Dispenser Article Code" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        v-if="showDispenserArticleCode" :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="consumableBrand" color="#213A8F" outlined :items="consumableBrands"
                        label="Consumable Brand" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        v-if="showConsumableBrand" :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="consumableArticleCode" color="#213A8F" outlined :items="consumableArticleCodes"
                        label="Consumable Article Code" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                        v-if="showConsumableArticleCode" :no-data-text="$t('common.noDataAvailable')" />
                    <v-select v-model="client" color="#213A8F" outlined :items="clients" label="Client"
                        prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                    <v-layout>
                        <v-flex xs-11 md-11 sm-11>
                            <v-select v-model="buildingValue" color="#213A8F" outlined :items="buildings"
                                label="Building" prepend-inner-icon="mdi-home"
                                append-icon="mdi-arrow-down-drop-circle-outline" append-icon-color="#213A8F"
                                v-if="showBuilding" :no-data-text="$t('common.noDataAvailable')" />
                        </v-flex>
                        <v-flex xs-1 md-1 sm-1>
                            <v-icon v-if="showBuilding" class="mt-4 mb-4" color="#213A8F" text
                                @click="CreateNewBuilding()">mdi-plus-circle-outline</v-icon></v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs-11 md-11 sm-11>
                            <v-select v-model="floorValue" color="#213A8F" outlined :items="floors" label="Floor"
                                prepend-inner-icon="mdi-floor-plan" append-icon="mdi-arrow-down-drop-circle-outline"
                                append-icon-color="#213A8F" :key="f" v-if="showFloor"
                                :no-data-text="$t('common.noDataAvailable')" />
                        </v-flex>
                        <v-flex xs-1 md-1 sm-1>
                            <v-icon v-if="showFloor" class="mt-4 mb-4" color="#213A8F" text
                                @click="CreateNewFloor()">mdi-plus-circle-outline</v-icon></v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs-11 md-11 sm-11>
                            <v-select v-model="areaValue" color="#213A8F" outlined :items="areas" label="Area"
                                prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                                append-icon-color="#213A8F" :key="a" v-if="showArea" :no-data-text="$t('common.noDataAvailable')" />
                        </v-flex>
                        <v-flex xs-1 md-1 sm-1>
                            <v-icon v-if="showArea" class="mt-4 mb-4" color="#213A8F" text
                                @click="CreateNewArea()">mdi-plus-circle-outline</v-icon></v-flex>
                    </v-layout>
                    <v-text-field v-if="sheetsVisible" outlined v-model="maxPaper"
                        label="Max N. of sheets"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="UpdateSensor">{{ $t('manageSensors.update') }}</v-btn>
                    <v-btn text color="#213A8F" @click="dialogEdit = false">{{ $t('common.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="errorDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">
                    Error
                </v-card-title>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#213A8F" text @click="errorDialog = false">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog for duplicate sensor error -->
        <v-dialog v-model="duplicateSensorDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">
                    Duplicate Sensor
                </v-card-title>
                <v-card-text>
                    The Sensor ID you entered already exists in the system. Please enter a different ID.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#213A8F" text @click="handleDuplicateSensorError">
                        OK
                    </v-btn>
                    <v-btn color="#213A8F" text @click="duplicateSensorDialog = false">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            id_deleting: 0,
            dialogAddArea: false,
            newAreaName: '',
            newBuildingAddress: '',
            nameDeleting: '',
            showDeleteAlert: false,
            search: '',
            filterClient: '',
            filterClients: [],
            filterBuilding: '',
            filterBuildings: [],
            filterFloor: '',
            filterFloors: [],
            filterArea: '',
            filterAreas: [],
            filterSensor: '',
            filterSensors: [],
            newBuildingName: '',
            newFloorName: '',
            dialogAddFloor: false,
            dialogAddBuilding: false,
            consumableArticleCodes: [],
            showConsumableArticleCode: false,
            consumableBrands: [],
            showConsumableBrand: false,
            dispenserArticleCodes: [],
            showDispenserArticleCode: false,
            showArea: false,
            areas: [],
            showFloor: false,
            floors: [],
            showBuilding: false,
            buildings: [],
            clients: [],
            dispenserBrands: [],
            areaValue: '',
            devEui: '',
            dispenserName: '',
            dispenserBrand: '',
            dispenserArticleCode: '',
            consumableBrand: '',
            consumableArticleCode: '',
            client: '',
            filterBuildingValue: "ALL",
            filterBuilding_items: [],
            building_items: [],
            addButton: true,
            f: 0,
            b: 0,
            floor_items: [],
            floorValue: "",
            buildingValue: [],
            sensorTypes: [],
            Tipologiasensore: '',
            deveui: '',
            sheetsVisible: false,
            maxPaper: 0,
            overlay: true,
            dialogAdd: false,
            items: [],
            items_all: [],
            dialogEdit: false,
            editingSensorId: null,
            editingSensorName: '',
            errorDialog: false,
            errorMessage: '',
            isFormValid: false,
            duplicateSensorDialog: false,
            rules: {
                required: v => !!v || 'This field is required',
                uniqueDevEui: async v => {
                    if (!v) return true; // Skip if empty (handled by required)
                    try {
                        const response = await axios.post(this.$store.state.URL_CHECK_SENSOR_EXISTS, {
                            devEui: v
                        });
                        if (response.data.exists) {
                            this.duplicateSensorDialog = true;
                            return false;
                        }
                        return true;
                    } catch (error) {
                        console.error('Error checking sensor existence:', error);
                        return false;
                    }
                }
            }
        }
    },
    created() {
        if (this.$store.state.company == null || this.$store.state.company == undefined || this.$store.state.company == '') {
            let token = localStorage.getItem("token");
            if (token != null && token != undefined && token != '') {
                axios.defaults.headers.common["Authorization"] = token;
                axios.post(this.$store.state.URL_REFRESH_TOKEN,
                    {

                    })
                    .then(res => {
                        if (res.data.result == "ok") {
                            this.$store.state.company = res.data.company;
                            localStorage.setItem('token', res.data.token);
                            localStorage.setItem('company', res.data.company)
                            this.$store.state.menu = res.data.menu;
                            console.log(this.$store.state.menu)
                            this.$store.state.avatar = res.data.avatar;
                            this.$store.state.displayName = res.data.displayName;
                            axios.defaults.headers.common["Authorization"] = res.data.token;
                            this.items = [];
                            axios
                .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                    { id_company: this.$store.state.company, 'type': this.$route.params.type })
                .then(async res => {
                    // Mappa base dei sensori
                    const baseItems = res.data.map(el => {
                        // Calcola dati washroom se presenti
                        const partialCount = Number(el.PartialCount) || 0;
                        const alertValue = Number(el.AlertValue) || 0;
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc > 60) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc >= 20 && perc <= 60) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        return {
                            stato: el.DispenserType == 'Dispenser' ? el.percentuale == -1 ? "gray" : el.percentuale < 15 ? "red" : (el.percentuale < 40 ? "orange" : "green") : '',
                            DispenserType: el.DispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off',
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: cleaningStatusColor
                        };
                    });

                    this.items = baseItems;
                    this.items_all = this.items;
                    this.filterBuilding_items = this.items.map(item => ({
                        text: item.BuildingName,
                        value: item.BuildingName
                    }));
                    this.filterBuilding_items.push({ text: "ALL", value: "ALL" });

                    this.DownloadCompanyDatas();
                    this.GetDispenserTypes();
                    this.overlay = false;
                })
                .catch(error => {
                    console.error('Error fetching sensor data:', error);
                    this.overlay = false; // Ensure overlay is removed even if there's an error
                });
                        }
                    })
            }
        }
        else {
            this.items = [];
            axios
                .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                    { id_company: this.$store.state.company, 'type': this.$route.params.type })
                .then(async res => {
                    // Mappa base dei sensori
                    const baseItems = res.data.map(el => {
                        // Calcola dati washroom se presenti
                        const partialCount = Number(el.PartialCount) || 0;
                        const alertValue = Number(el.AlertValue) || 0;
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc > 60) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc >= 20 && perc <= 60) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        return {
                            stato: el.DispenserType == 'Dispenser' ? el.percentuale == -1 ? "gray" : el.percentuale < 15 ? "red" : (el.percentuale < 40 ? "orange" : "green") : '',
                            DispenserType: el.DispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off',
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: cleaningStatusColor
                        };
                    });

                    this.items = baseItems;
                    this.items_all = this.items;
                    this.filterBuilding_items = this.items.map(item => ({
                        text: item.BuildingName,
                        value: item.BuildingName
                    }));
                    this.filterBuilding_items.push({ text: "ALL", value: "ALL" });

                    this.DownloadCompanyDatas();
                    this.GetDispenserTypes();
                    this.overlay = false;
                })
                .catch(error => {
                    console.error('Error fetching sensor data:', error);
                    this.overlay = false; // Ensure overlay is removed even if there's an error
                });
        }
    },
    methods: {
        async loadWashroomData(items) {
            // Carica i dati di utilizzo e soglia per ogni sensore washroom
            const promises = items.map(async item => {
                try {
                    const response = await axios.post(this.$store.state.URL_LASTMANAGED, {
                        sensor: item.id
                    });
                    
                    if (response.data && response.data.length > 0) {
                        const data = response.data[0];
                        const alertValue = Number(data.AlertValue) || 0;
                        const partialCount = Number(data.PartialCount) || 0;
                        
                        // Calcola la percentuale di utilizzo
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        // Imposta il colore del pallino in base alla percentuale
                        if (perc > 60) {
                            item.cleaningStatusColor = "red";
                            item.cleaningStatus = "Cleaning Required";
                        } else if (perc >= 20 && perc <= 60) {
                            item.cleaningStatusColor = "#ffac27";
                            item.cleaningStatus = "Might need clean";
                        } else {
                            item.cleaningStatusColor = "green";
                            item.cleaningStatus = "Doesn't need clean";
                        }
                        
                        // Imposta Live Usage e Cleaning Limit
                        item.liveUsage = partialCount;
                        item.cleaningLimit = alertValue > 0 ? alertValue : '-';
                        item.status = 'on';
                    }
                } catch (error) {
                    console.error(`Error loading washroom data for sensor ${item.id}:`, error);
                }
            });
            
            await Promise.all(promises);
        },
        CreateBuilding() {
            axios
                .post(`${this.$store.state.URL_CREATE_BUILDING}`,
                    { buildingName: this.newBuildingName, 'address': this.newBuildingAddress, 'companyId': this.client })
                .then(() => {
                    axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                        companyId: this.client
                    })
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.BuildingName, value: el.id }
                                this.buildings.push(element);

                            });
                            this.dialogAddBuilding = false;
                        })

                })
        },
        CreateFloor() {
            axios
                .post(`${this.$store.state.URL_CREATE_FLOOR}`,
                    { floorName: this.newFloorName, buildingId: this.buildingValue })
                .then(() => {
                    axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                        buildingId: this.buildingValue
                    })
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.FloorName, value: el.id }
                                this.floors.push(element);

                            });
                            this.dialogAddFloor = false;
                        })

                })

        },
        CreateArea() {
            axios
                .post(`${this.$store.state.URL_CREATE_AREA}`,
                    { areaName: this.newAreaName, floorId: this.floorValue })
                .then(() => {
                    axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: this.floorValue
                    })
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.AreaName, value: el.id }
                                this.areas.push(element);

                            });
                            this.dialogAddArea = false;
                        })

                })
        },
        CreateNewArea() {
            this.dialogAddArea = true;
        },
        AlertDeleting(_id, _name) {
            this.id_deleting = _id;
            this.nameDeleting = _name;
            this.showDeleteAlert = true;

        },
        ConfirmDelete() {
            axios
                .post(`${this.$store.state.URL_DELETE_SENSOR}`, {
                    id: this.id_deleting
                })
                .then(() => {
                    this.showDeleteAlert = false;
                    this.Filter();
                })
        },
        CreateSensor() {
            axios
                .post(`${this.$store.state.URL_CREATE_NEW_SENSOR}`, {
                    dispenserArticleCodeId: this.dispenserArticleCode,
                    brandId: this.dispenserBrand,
                    companyId: this.client,
                    sensorName: this.dispenserName,
                    floorId: this.floorValue,
                    devEui: this.devEui.toUpperCase(),
                    dispenserModelId: this.dispenserArticleCode,
                    dispenserBrandId: this.dispenserBrand,
                    idArea: this.areaValue,
                    idConsumableBrand: this.consumableBrand,
                    idConsumableArticleCode: this.consumableArticleCode,
                    idBuilding: this.buildingValue

                })
                .then(res => {
                    console.log(res.data.message)
                    if (res.data.message === "Sensor created successfully") {
                        this.dialogAdd = false;
                        this.Filter();
                    }
                })
        },
        CreateNewBuilding() {
            this.dialogAddBuilding = true;
            this.newBuildingAddress = '';
            this.newBuildingName = '';
        },
        CreateNewFloor() {
            this.dialogAddFloor = true;
            this.newFloorName = '';
        },
        CreateNew() {
            this.floors.length = 0;
            this.areas.length = 0;
            this.sheetsVisible = false;
            this.Tipologiasensore = '';
            this.buildingValue = '';
            this.floorValue = '';
            this.maxPaper = 0;
            this.areaValue = '';
            this.devEui = '';
            this.dispenserName = '';
            this.dispenserBrand = '';
            this.dispenserArticleCode = '';
            this.consumableBrand = '';
            this.consumableArticleCode = '';
            this.client = '';
            this.buildingValue = '';
            this.overlay = true;
            this.showDispenserArticleCode = false;
            this.showArea = false;
            this.showFloor = false;
            this.showBuilding = false;
            this.consumableBrands.length = 0;
            this.showConsumableBrand = false;
            this.showConsumableArticleCode = false;

            // Reset della validazione del form
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }
            });

            this.LoadComponentData();
        },
        ClearFilter() {
            this.filterClient = '';
            this.filterBuildings.length = 0;
            this.filterBuilding = '';
            this.filterFloor = '';
            this.filterFloors.length = 0;
            this.filterArea = '';
            this.filterAreas.length = 0;
            this.filterSensors.length = 0;
            this.filterSensor = '';
            this.filterBuildings = [];
            this.filterFloors = [];
            this.filterAreas = [];
            this.filterSensors = [];
            this.Filter();
        },
        async Filter() {
            this.overlay = true;
            axios
                .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                    {
                        id_company: this.$store.state.company,
                        'type': this.$route.params.type,
                        "companyId": this.$store.state.company,
                        "clientId": this.filterClient,
                        "buildingId": this.filterBuilding,
                        "floorId": this.filterFloor,
                        "areaId": this.filterArea,
                        "sensorId": this.filterSensor
                    })

                .then(async res => {
                    const baseItems = res.data.map(el => {
                        // Calcola dati washroom se presenti
                        const partialCount = Number(el.PartialCount) || 0;
                        const alertValue = Number(el.AlertValue) || 0;
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc > 60) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc >= 20 && perc <= 60) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        return {
                            stato: el.DispenserType == 'Dispenser' ? el.percentuale == -1 ? "gray" : el.percentuale < 15 ? "red" : (el.percentuale < 40 ? "orange" : "green") : '',
                            DispenserType: el.DispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off',
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: cleaningStatusColor
                        };
                    });

                    this.items = baseItems;

                    // this.items_all = this.items;
                    // this.filterBuilding_items = this.items.map(item => ({
                    //     text: item.BuildingName,
                    //     value: item.BuildingName
                    // }));
                    // this.filterBuilding_items.push({ text: "ALL", value: "ALL" });
                    // this.DownloadCompanyDatas();
                    // this.GetDispenserTypes();
                    this.overlay = false;
                })
        },
        LoadComponentData() {
            axios.post(this.$store.state.URL_GET_DISPENSER_BRAND)
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.DispenserBrandame, value: el.id }
                        this.dispenserBrands.push(element);
                    })
                    axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.CompanyName, value: el.id }
                                this.clients.push(element);

                            })
                            axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS)
                                .then(res => {
                                    res.data.forEach(el => {
                                        var element = { text: el.Brand, value: el.id }
                                        this.consumableBrands.push(element);
                                    })
                                    this.overlay = false;
                                    this.dialogAdd = true;
                                })
                                .catch(() => {
                                    this.overlay = false;
                                })
                        })
                        .catch(() => {
                            this.overlay = false;
                        })
                })
                .catch(() => {
                    this.overlay = false;
                });
        },
        GetDispenserTypes() {
            this.sensorTypes.length = 0;
            axios.post(this.$store.state.URL_DISPENSERTYPE, {
                "company": this.$store.state.company
            })
                .then(res => {
                    if (res.data.length > 0) {
                        res.data.forEach(el => {
                            this.sensorTypes.push({ text: el.DispenserTypeName, value: el });
                        })
                    }
                    //else {
                    //    this.addButton = false;
                    //}
                })
        },
        DownloadCompanyDatas() {
            axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
                .then(res => {
                    res.data.forEach(el => {
                        var element = { text: el.CompanyName, value: el.id }
                        this.filterClients.push(element);

                    })
                })
                .catch(() => {
                    this.overlay = false;
                    this.$router.push({ path: "/" });
                })
            axios.post(this.$store.state.URL_COMPANY_DATA, {
                "Company": this.$store.state.company
            })
                .then(res => {
                    this.$store.state.building = res.data
                    this.building_items.length = 0;
                    this.floor_items.length = 0;

                    this.$store.state.building.buildings.forEach(el => {
                        var found = false;
                        var c = 0;
                        el.floors.forEach(e => {
                            e.sensors.forEach(s => {
                                found = Object.values(s).includes("Dispenser")
                                if (found)
                                    c++;
                                console.log(e, found)
                            })

                        })

                        if (c > 0) {
                            if (this.$store.state.company == '1')
                                this.building_items.push({ text: el.BuildingName.replace('Zwetko Headquarter', 'Airport'), value: el });
                            else
                                this.building_items.push({ text: el.BuildingName, value: el });
                        }
                    })
                })
                .catch(() => {
                    //Redirect alla pagina di errore
                    //this.snackbar = true;
                })
        },
        CheckInvio(evt) {
            if (evt != null && evt != undefined) {

                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode === 13) {
                    this.Login();
                }
            }
        },
        async GetSensorsData() {
            this.overlay = true;
            axios
                .post(`${this.$store.state.URL_SENSORSMANAGEMENT}`,
                    { id_company: this.$store.state.company, 'type': this.$route.params.type })
                .then(async res => {
                    const baseItems = res.data.map(el => {
                        // Calcola dati washroom se presenti
                        const partialCount = Number(el.PartialCount) || 0;
                        const alertValue = Number(el.AlertValue) || 0;
                        const perc = alertValue > 0 ? (partialCount * 100) / alertValue : 0;
                        
                        let cleaningStatusColor = 'gray';
                        let cleaningStatus = '';
                        
                        if (el.DispenserType === 'Washroom' && alertValue > 0) {
                            if (perc > 60) {
                                cleaningStatusColor = "red";
                                cleaningStatus = "Cleaning Required";
                            } else if (perc >= 20 && perc <= 60) {
                                cleaningStatusColor = "#ffac27";
                                cleaningStatus = "Might need clean";
                            } else {
                                cleaningStatusColor = "green";
                                cleaningStatus = "Doesn't need clean";
                            }
                        }
                        
                        return {
                            stato: el.DispenserType == 'Dispenser' ? el.percentuale == -1 ? "gray" : el.percentuale < 15 ? "red" : (el.percentuale < 40 ? "orange" : "green") : '',
                            DispenserType: el.DispenserImage,
                            percentuale: el.DispenserType == 'Dispenser' ? el.percentuale : '',
                            name: el.DisplayName,
                            Company: el.CompanyName,
                            BuildingName: el.BuildingName,
                            floor: el.FloorName,
                            status: el.DispenserType == 'Dispenser' || (el.DispenserType === 'Washroom' && alertValue > 0) ? 'on' : 'off',
                            battery: el.BatteryLevel,
                            Area: el.AreaName,
                            sensorId: el.DispenserUnique,
                            id: el.id,
                            liveUsage: partialCount,
                            cleaningLimit: alertValue > 0 ? alertValue : '-',
                            cleaningStatus: cleaningStatus,
                            cleaningStatusColor: cleaningStatusColor
                        };
                    });

                    this.items = baseItems;
                    this.items_all = this.items;
                    this.filterBuilding_items = this.items.map(item => ({
                        text: item.BuildingName,
                        value: item.BuildingName
                    }));
                    this.filterBuilding_items.push({ text: "ALL", value: "ALL" });

                    this.DownloadCompanyDatas();
                    this.GetDispenserTypes();
                    this.overlay = false;
                })
                .catch(error => {
                    console.error('Error fetching sensor data:', error);
                    this.overlay = false; // Ensure overlay is removed even if there's an error
                });
        },
        editSensor(item) {
            this.editingSensorId = item.id;
            this.editingSensorName = item.name;
            this.overlay = true;

            // Reset dei campi
            this.devEui = '';
            this.dispenserName = '';
            this.dispenserBrand = '';
            this.dispenserArticleCode = '';
            this.consumableBrand = '';
            this.consumableArticleCode = '';
            this.client = '';
            this.buildingValue = '';
            this.floorValue = '';
            this.areaValue = '';
            
            // Reset delle liste
            this.dispenserBrands = [];
            this.dispenserArticleCodes = [];
            this.consumableBrands = [];
            this.consumableArticleCodes = [];
            this.clients = [];
            this.buildings = [];
            this.floors = [];
            this.areas = [];
            
            // Reset delle visibilità
            this.showDispenserArticleCode = false;
            this.showConsumableBrand = false;
            this.showConsumableArticleCode = false;
            this.showBuilding = false;
            this.showFloor = false;
            this.showArea = false;

            // Carica prima i dati di base necessari
            let sensorDetails = null;
            
            this.loadEditFormData().then(() => {
                // Ottieni i dettagli completi del dispenser
                const url = this.$store.state.BASE_PATH + this.$store.state.URL_GET_SINGLE_DISPENSER.replace(':id', item.id);
                const token = localStorage.getItem("token");
                return axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            }).then(res => {
                sensorDetails = res.data;
                
                console.log('Sensor details from API:', sensorDetails);

                // Popola i campi con i dati esistenti
                this.devEui = sensorDetails.DispenserUnique || item.sensorId;
                this.dispenserName = sensorDetails.DisplayName || item.name;
                this.client = sensorDetails.companyId || '';

                // Mostra e carica i dati dell'edificio
                this.showBuilding = true;
                return axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: this.client
                });
            }).then(res => {
                res.data.forEach(el => {
                    var element = { text: el.BuildingName, value: el.id }
                    this.buildings.push(element);
                });
                
                // Imposta il valore del building dopo aver caricato la lista
                this.buildingValue = sensorDetails.buildingId ? parseInt(sensorDetails.buildingId) : '';

                // Carica i piani se c'è un edificio selezionato
                const buildingId = sensorDetails.buildingId || '';
                if (buildingId) {
                    this.showFloor = true;
                    return axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                        buildingId: buildingId
                    });
                }
                return Promise.resolve({ data: [] });
            }).then(res => {
                if (res.data.length > 0) {
                    res.data.forEach(el => {
                        var element = { text: el.FloorName, value: el.id }
                        this.floors.push(element);
                    });
                }
                
                // Imposta il valore del floor dopo aver caricato la lista
                this.floorValue = sensorDetails.floorId ? parseInt(sensorDetails.floorId) : '';

                // Carica le aree se c'è un piano selezionato
                const floorId = sensorDetails.floorId || '';
                if (floorId) {
                    this.showArea = true;
                    return axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                        floorId: floorId
                    });
                }
                return Promise.resolve({ data: [] });
            }).then(res => {
                if (res.data.length > 0) {
                    res.data.forEach(el => {
                        var element = { text: el.AreaName, value: el.id }
                        this.areas.push(element);
                    });
                }
                
                // Imposta il valore dell'area dopo aver caricato la lista
                this.areaValue = sensorDetails.areaId ? parseInt(sensorDetails.areaId) : '';

                // Imposta il valore del dispenser brand (la lista è già disponibile da loadEditFormData)
                this.dispenserBrand = sensorDetails.dispenserBrand ? parseInt(sensorDetails.dispenserBrand) : '';
                
                // Carica i codici articolo del dispenser se c'è un brand selezionato
                const dispenserBrandId = sensorDetails.dispenserBrand || '';
                if (dispenserBrandId) {
                    this.showDispenserArticleCode = true;
                    return axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                        idDispenserBrand: dispenserBrandId
                    });
                }
                return Promise.resolve({ data: [] });
            }).then(res => {
                if (res.data.length > 0) {
                    res.data.forEach(el => {
                        var element = { text: el.ArticleCode + " - " + el.Description, value: el.id }
                        this.dispenserArticleCodes.push(element);
                    });
                }
                
                // Debug: verifica corrispondenza tra valore API e opzioni select
                const dispenserModelFromAPI = sensorDetails.dispenserModel;
                console.log('Dispenser model from API:', dispenserModelFromAPI);
                console.log('Available dispenser article codes:', this.dispenserArticleCodes);
                
                // Cerca il valore corrispondente nella lista
                const matchingOption = this.dispenserArticleCodes.find(option => 
                    option.value == dispenserModelFromAPI || 
                    option.value === parseInt(dispenserModelFromAPI)
                );
                console.log('Matching option found:', matchingOption);
                
                // Imposta il valore del dispenser article code dopo aver caricato la lista
                this.dispenserArticleCode = matchingOption ? matchingOption.value : '';

                // Carica i modelli consumabili se necessario
                const consumableBrandId = sensorDetails.consumableBrandId || '';
                const dispenserArticleCodeId = sensorDetails.dispenserModel || '';
                if (consumableBrandId && dispenserArticleCodeId) {
                    this.showConsumableArticleCode = true;
                    return axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                        consumableBrand: consumableBrandId,
                        dispenserId: dispenserArticleCodeId
                    });
                }
                return Promise.resolve({ data: [] });
            }).then(res => {
                if (res.data.length > 0) {
                    res.data.forEach(el => {
                        var element = { text: el.ArtcleCode + " - " + el.Name, value: el.id }
                        this.consumableArticleCodes.push(element);
                    });
                }
                
                // Debug: verifica corrispondenza per consumable article code
                const consumableArticleCodeFromAPI = sensorDetails.consumableArticleId;
                console.log('Consumable article code from API:', consumableArticleCodeFromAPI);
                console.log('Available consumable article codes:', this.consumableArticleCodes);
                
                // Cerca il valore corrispondente nella lista
                const matchingConsumableOption = this.consumableArticleCodes.find(option => 
                    option.value == consumableArticleCodeFromAPI || 
                    option.value === parseInt(consumableArticleCodeFromAPI)
                );
                console.log('Matching consumable option found:', matchingConsumableOption);
                
                // Imposta il valore del consumable article code dopo aver caricato la lista
                this.consumableArticleCode = matchingConsumableOption ? matchingConsumableOption.value : '';

                // Mostra la sezione del brand consumabile
                this.showConsumableBrand = true;

                // Imposta tutti i valori dopo che i dati sono stati caricati
                this.$nextTick(() => {
                    // Imposta il consumable brand dopo che la lista è stata renderizzata
                    this.consumableBrand = sensorDetails.consumableBrandId ? parseInt(sensorDetails.consumableBrandId) : '';
                    
                    // Se abbiamo un consumable brand e un dispenser article code, ricarica i consumable article codes
                    const consumableBrandId = sensorDetails.consumableBrandId;
                    const dispenserArticleCodeId = sensorDetails.dispenserModel;
                    
                    if (consumableBrandId && dispenserArticleCodeId) {
                        this.showConsumableArticleCode = true;
                        axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                            consumableBrand: consumableBrandId,
                            dispenserId: dispenserArticleCodeId
                        }).then(res => {
                            // Reset e ricarica la lista
                            this.consumableArticleCodes = [];
                            
                            if (res.data.length > 0) {
                                res.data.forEach(el => {
                                    var element = { text: el.ArtcleCode + " - " + el.Name, value: el.id }
                                    this.consumableArticleCodes.push(element);
                                });
                            }
                            
                            // Debug e imposta il valore del consumable article code
                            const consumableArticleIdFromAPI = sensorDetails.consumableArticleId;
                            console.log('Consumable article ID from API (in nextTick):', consumableArticleIdFromAPI);
                            console.log('Available consumable article codes (in nextTick):', this.consumableArticleCodes);
                            
                            // Cerca la corrispondenza
                            const matchingConsumableOption = this.consumableArticleCodes.find(option => 
                                option.value == consumableArticleIdFromAPI || 
                                option.value === parseInt(consumableArticleIdFromAPI)
                            );
                            console.log('Matching consumable option found (in nextTick):', matchingConsumableOption);
                            
                            // Imposta il valore
                            this.consumableArticleCode = matchingConsumableOption ? matchingConsumableOption.value : '';
                            
                            console.log('All values set:', {
                                buildingValue: this.buildingValue,
                                floorValue: this.floorValue,
                                areaValue: this.areaValue,
                                dispenserBrand: this.dispenserBrand,
                                dispenserArticleCode: this.dispenserArticleCode,
                                consumableBrand: this.consumableBrand,
                                consumableArticleCode: this.consumableArticleCode
                            });
                        });
                    } else {
                        console.log('All values set (no consumable article codes):', {
                            buildingValue: this.buildingValue,
                            floorValue: this.floorValue,
                            areaValue: this.areaValue,
                            dispenserBrand: this.dispenserBrand,
                            dispenserArticleCode: this.dispenserArticleCode,
                            consumableBrand: this.consumableBrand,
                            consumableArticleCode: this.consumableArticleCode
                        });
                    }
                });

                this.overlay = false;
                this.dialogEdit = true;
            }).catch(error => {
                console.error('Error in edit sensor process:', error);
                this.overlay = false;
                this.showError('Error loading sensor data for editing');
            });
        },

        // Metodo per caricare i dati di base per il form di modifica
        loadEditFormData() {
            return new Promise((resolve, reject) => {
                // Carica i brand dei dispenser
                axios.post(this.$store.state.URL_GET_DISPENSER_BRAND)
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DispenserBrandame, value: el.id }
                            this.dispenserBrands.push(element);
                        });

                        // Carica i clienti
                        return axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT);
                    })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.CompanyName, value: el.id }
                            this.clients.push(element);
                        });

                        // Carica i brand dei consumabili
                        return axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS);
                    })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.Brand, value: el.id }
                            this.consumableBrands.push(element);
                        });

                        resolve();
                    })
                    .catch(error => {
                        console.error('Error loading form data:', error);
                        reject(error);
                    });
            });
        },

        // Metodi di supporto per caricare dati correlati in base alle selezioni
        loadDispenserArticleCodes(brandId, selectedCodeId = null) {
            this.showDispenserArticleCode = true;
            this.dispenserArticleCodes = [];
            this.dispenserArticleCode = '';

            return axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                idDispenserBrand: brandId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.dispenserArticleCodes.push({
                            text: el.ArticleCode + " - " + el.Description,
                            value: el.id
                        });
                    });

                    if (selectedCodeId) {
                        this.dispenserArticleCode = selectedCodeId;
                    }
                });
        },

        loadFloors(buildingId, selectedFloorId = null) {
            this.showFloor = true;
            this.floors = [];
            this.floorValue = '';

            return axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                buildingId: buildingId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.floors.push({
                            text: el.FloorName,
                            value: el.id
                        });
                    });

                    if (selectedFloorId) {
                        this.floorValue = selectedFloorId;
                    }
                });
        },

        loadAreas(floorId, selectedAreaId = null) {
            this.showArea = true;
            this.areas = [];
            this.areaValue = '';

            return axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                floorId: floorId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.areas.push({
                            text: el.AreaName,
                            value: el.id
                        });
                    });

                    if (selectedAreaId) {
                        this.areaValue = selectedAreaId;
                    }
                });
        },

        loadConsumableArticleCodes(brandId, dispenserId, selectedCodeId = null) {
            this.showConsumableArticleCode = true;
            this.consumableArticleCodes = [];
            this.consumableArticleCode = '';

            return axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                consumableBrand: brandId,
                dispenserId: dispenserId
            })
                .then(res => {
                    res.data.forEach(el => {
                        this.consumableArticleCodes.push({
                            text: el.ArtcleCode + " - " + el.Name,
                            value: el.id
                        });
                    });

                    if (selectedCodeId) {
                        this.consumableArticleCode = selectedCodeId;
                    }
                });
        },

        UpdateSensor() {
            if (!this.dispenserName || !this.client || !this.buildingValue || !this.floorValue || !this.areaValue) {
                this.showError('Error updating sensor');
                return;
            }

            this.overlay = true;

            const url = this.$store.state.BASE_PATH + this.$store.state.URL_PUT_SINGLE_DISPENSER.replace(':id', this.editingSensorId);
            const token = localStorage.getItem("token");
            
            axios.put(url, {
                companyId: this.client,
                displayName: this.dispenserName,
                floorId: this.floorValue,
                dispenserModel: this.dispenserArticleCode.toString(),
                dispenserBrand: this.dispenserBrand.toString(),
                areaId: this.areaValue,
                consumableBrandId: this.consumableBrand,
                consumableArticleId: this.consumableArticleCode,
                buildingId: this.buildingValue
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(res => {
                    if (res.data.message === "Sensor updated successfully" || res.status === 200) {
                        this.dialogEdit = false;
                        // Mantieni l'overlay attivo per mostrare il caricamento durante il reload della lista
                        this.Filter(); // Aggiorna la lista dei sensori (disattiverà l'overlay automaticamente)
                    } else {
                        this.showError('Error updating sensor');
                        this.overlay = false;
                    }
                })
                .catch(error => {
                    console.error('Error updating sensor:', error);
                    this.showError('Error updating sensor');
                    this.overlay = false;
                });
        },
        showError(message) {
            this.errorMessage = message;
            this.errorDialog = true;
        },
        handleDuplicateSensorError() {
            this.duplicateSensorDialog = false;
            // Focus on Sensor ID field
            this.$nextTick(() => {
                const sensorIdField = this.$el.querySelector('input[type="text"]');
                if (sensorIdField) {
                    sensorIdField.focus();
                }
            });
        },
        navigateToSmartDispenser(item) {
            this.$router.push({
                name: 'SmartDispenser',
                params: {
                    id: item.id,
                    sensorId: item.sensorId,
                    company: item.Company,
                    building: item.BuildingName,
                    floor: item.floor,
                    area: item.Area
                }
            });
        },
        navigateToSmartCleaning(item) {
            console.log(item, this.$store.state.type);
            if (this.$route.params.type === 'washroom') {
                // Trova gli ID corretti dai valori
                const clientObj = this.filterClients.find(c => c.text === item.Company);
                const buildingObj = this.filterBuildings.find(b => b.text === item.BuildingName);
                const floorObj = this.filterFloors.find(f => f.text === item.floor);
                const areaObj = this.filterAreas.find(a => a.text === item.Area);
                
                this.$router.push({
                    name: 'WhasroomFrequencyView',
                    params: {
                        company: clientObj ? clientObj.value : item.Company,
                        building: buildingObj ? buildingObj.value : item.BuildingName,
                        floor: floorObj ? floorObj.value : item.floor,
                        area: areaObj ? areaObj.value : item.Area,
                        sensorId: item.id,
                        id: item.id
                    }
                });
            }
        }
    },
    watch: {
        '$route.params.type': function (type) {
            console.log(type)
            var typologies = ['dispenser', 'washroom', 'button', 'air'];
            if (typologies.includes(type)) {
                this.GetSensorsData();
            }
        },
        client(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = false;
                this.showArea = false;
                this.floors.length = 0;
                this.areas.length = 0;
                this.showBuilding = true;
                this.buildings.length = 0;
                this.buildingValue = '';

                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.buildings.push(element);

                        });
                    })
            }
            else {
                this.showBuilding = false;
                this.buildings.length = 0;
                this.buildingValue = '';
            }
        },
        buildingValue(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = true;
                this.floors.length = 0;
                this.floorValue = '';
                this.floors = [];
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.floors.push(element);
                        });

                    })
            }
            else {
                this.showFloor = false;
                this.floors.length = 0;
                this.floorValue = '';
            }
        },
        filterBuildingValue(value) {
            if (value == "ALL") {
                this.items = this.items_all;
            }
            else {
                this.items = this.items_all.filter(p => p.BuildingName == value);
            }
        },
        floorValue(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showArea = true;
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.areas.push(element);
                        });

                    })
            }

        },
        dispenserBrand(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showDispenserArticleCode = true;
                this.dispenserArticleCodes.length = 0;
                this.dispenserArticleCode = '';
                this.consumableArticleCode = '';
                this.consumableArticleCodes.length = 0;
                axios.post(this.$store.state.URL_GET_DISPENSER_CODES, {
                    idDispenserBrand: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.ArticleCode + " - " + el.Description, value: el.id }
                            this.dispenserArticleCodes.push(element);
                        });

                    })
            }
        },
        dispenserArticleCode(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.consumableArticleCode = '';
                this.consumableArticleCodes.length = 0;
                this.showConsumableBrand = true;
                this.consumableBrands = [];
                this.consumableBrands.length = 0;
                this.consumableBrand = '';
                axios.post(this.$store.state.URL_GET_CONSUMABLE_BRANDS)
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.Brand, value: el.id }
                            this.consumableBrands.push(element);
                        })
                    })
            }
        },
        consumableBrand(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showConsumableArticleCode = true;
                this.consumableArticleCodes.length = 0;
                this.consumableArticleCode = '';
                axios.post(this.$store.state.URL_GET_CONSUMABLE_MODELS, {
                    consumableBrand: value,
                    dispenserId: this.dispenserArticleCode
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.ArtcleCode + " - " + el.Name, value: el.id }
                            this.consumableArticleCodes.push(element);
                        });

                    })
            }
        },
        Tipologiasensore(value) {
            this.sheetsVisible = false;
            if (value.DispenserPaperType == 'Foglietti') {
                this.sheetsVisible = true;
            }
            console.log(value)
        },
        filterClient(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = []
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildins = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterBuildings.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.filterBuildings.push(element);

                        });
                    })
            }
            else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = []
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildins = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        filterBuilding(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterFloors.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.filterFloors.push(element);
                        });

                    })
            } else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        filterFloor(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterAreas = [];
                this.filterArea = '';
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterAreas.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.filterAreas.push(element);
                        });

                    })
            }
            else {
                this.filterAreas.length = 0;
                this.filterAreas = [];
                this.filterArea = '';
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        filterArea(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterSensors.push(el);
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.filterClient,
                    buildingId: this.filterBuilding,
                    floorId: this.filterFloor,
                    areaId: value,
                    type: this.$route.params.type
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DispenserUnique, value: el.id }
                            this.filterSensors.push(element);
                        });

                    })
            }
            else {
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        }
    },
    computed: {
        headers() {
            // Headers specifici per washroom
            if (this.$route.params.type === 'washroom') {
                return [
                    {},
                    { text: this.$t('manageSensors.type'), align: "center", value: "DispenserType" },
                    { text: this.$t('manageSensors.liveUsage'), align: "center", value: "liveUsage" },
                    { text: this.$t('manageSensors.cleaningLimit'), align: "center", value: "cleaningLimit" },
                    { text: this.$t('manageSensors.name'), align: "center", value: "name" },
                    { text: this.$t('manageSensors.company'), align: "center", value: "Company" },
                    { text: this.$t('manageSensors.building'), align: "center", value: "BuildingName" },
                    { text: this.$t('manageSensors.floor'), align: "center", value: "floor" },
                    { text: this.$t('manageSensors.area'), align: "center", value: "Area" },
                    { text: this.$t('manageSensors.battery'), align: "center", value: "Battery" },
                    { text: this.$t('manageSensors.sensorId'), align: "center", value: "sensorId" },
                    {},
                ];
            }
            
            // Headers per altri tipi (dispenser, etc.)
            return [{},
            { text: this.$t('manageSensors.type'), align: "center", value: "DispenserType" },
            { text: this.$t('manageSensors.fillLevel'), align: "center", value: "percentuale" },
            { text: this.$t('manageSensors.name'), align: "center", value: "name" },
            { text: this.$t('manageSensors.company'), align: "center", value: "Company" },
            { text: this.$t('manageSensors.building'), align: "center", value: "BuildingName" },
            { text: this.$t('manageSensors.floor'), align: "center", value: "floor" },
            { text: this.$t('manageSensors.area'), align: "center", value: "Area" },
            { text: this.$t('manageSensors.battery'), align: "center", value: "Battery" },
            { text: this.$t('manageSensors.sensorId'), align: "center", value: "sensorId" },
            {},
            ]
        },
        filteredHeaders() {
            return this.headers.filter(header => {
                if (header.text === this.$t('manageSensors.fillLevel')) {
                    return this.$route.params.type === 'dispenser';
                }
                return true;
            });
        }
    }
}
</script>